import React, { useEffect, useId, useState } from "react";
import { message, Modal } from "antd";
import { changeOwnPassword, fetchProfile, logout, saveAvatar } from "../api/auth";
import { ANIMALS, animalFor } from "./animalAvatars";
import avatarStyles from "./AnimalAvatar.module.css";
import styles from "../styles.module.css";

// [[Employee Management Flow]] #obsidian-marker
export default function ProfileControl({ session, className, children }) {
    const fieldId = useId();
    const [avatar, setAvatar] = useState(session?.avatar);
    const [avatarLoading, setAvatarLoading] = useState(false);
    useEffect(() => {
        let cancelled = false;
        fetchProfile().then(value => { if (!cancelled) setAvatar(value.avatar); }).catch(() => {});
        return () => { cancelled = true; };
    }, [session?.employeeId]);
    const animal = animalFor(avatar, session?.employeeId);
    const avatarNode = <span className={avatarStyles.avatar} role="img" aria-label={animal[2]}>{animal[1]}</span>;
    const chooseAvatar = async value => {
        setAvatarLoading(true);
        try { const saved = await saveAvatar(value); setAvatar(saved.avatar); message.success("Аватарка сохранена"); }
        catch (error) { message.error(error.message); }
        finally { setAvatarLoading(false); }
    };
    const [profileOpen, setProfileOpen] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [passwordLoading, setPasswordLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const closeProfile = () => {
        setProfileOpen(false);
        setCurrentPassword("");
        setNewPassword("");
    };

    const openProfile = async () => {
        setProfile(null);
        setProfileOpen(true);
        try {
            setProfile(await fetchProfile());
        } catch {
            message.error("Не удалось загрузить профиль");
        }
    };

    const handlePasswordChange = async () => {
        if (!currentPassword || newPassword.length < 8 || newPassword.length > 72) {
            message.warning("Новый пароль должен содержать от 8 до 72 символов");
            return;
        }

        setPasswordLoading(true);
        try {
            await changeOwnPassword(currentPassword, newPassword);
            message.success("Пароль изменён. Войдите заново.");
            closeProfile();
        } catch (error) {
            message.error(error.message || "Не удалось изменить пароль");
        } finally {
            setPasswordLoading(false);
        }
    };

    return <>
        <button type="button" className={className} onClick={openProfile} title="Профиль сотрудника" aria-label="Профиль сотрудника">
            {typeof children === "function" ? children(avatarNode) : <>{avatarNode}{children || session?.employeeName || "Профиль"}</>}
        </button>
            <Modal
                open={profileOpen}
                title="Профиль сотрудника"
                okText="Сменить пароль"
                cancelText="Закрыть"
                confirmLoading={passwordLoading}
                onCancel={closeProfile}
                onOk={handlePasswordChange}
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <button type="button" className={styles.profileLogoutButton} onClick={logout}>
                            Выйти
                        </button>
                        <CancelBtn />
                        <OkBtn />
                    </>
                )}
            >
                <div><strong>Аватарка</strong><div className={avatarStyles.choices} aria-label="Выбор аватарки">
                    {ANIMALS.map(([id, icon, name]) => <button key={id} type="button" title={name} aria-label={name} aria-pressed={animal[0] === id} disabled={avatarLoading} onClick={() => chooseAvatar(id)}>{icon}</button>)}
                </div></div>
                <p><strong>{profile?.name || session?.employeeName}</strong></p>
                <p className={styles.profileMeta}>Email: {profile?.email || "—"}</p>
                <p className={styles.profileMeta}>Телефон: {profile?.phone_number || "—"}</p>
                <p className={styles.profileMeta}>Роли: {(profile?.roles || session?.roles)?.join(", ") || "—"}</p>

                <label className={styles.profileLabel} htmlFor={`${fieldId}-current-password`}>Текущий пароль</label>
                <input
                    id={`${fieldId}-current-password`}
                    className={styles.profileInput}
                    type="password"
                    autoComplete="current-password"
                    value={currentPassword}
                    onChange={event => setCurrentPassword(event.target.value)}
                />

                <label className={styles.profileLabel} htmlFor={`${fieldId}-new-password`}>Новый пароль</label>
                <input
                    id={`${fieldId}-new-password`}
                    className={styles.profileInput}
                    type="password"
                    autoComplete="new-password"
                    value={newPassword}
                    minLength={8}
                    maxLength={72}
                    onChange={event => setNewPassword(event.target.value)}
                />
            </Modal>

    </>;
}
